import React, { useState } from "react"
import { CalendarDays, Check, Sparkles, UsersRound } from "lucide-react"
import { useAuth } from "../auth"
import { Link } from "../router"
import { Button, ErrorNotice } from "../ui"

export function AuthPage() {
  const { login, register } = useAuth()
  const [mode, setMode] = useState("login")
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  async function submit(event) {
    event.preventDefault()
    const data = Object.fromEntries(new FormData(event.currentTarget))
    setBusy(true)
    setError(null)
    try {
      await (mode === "login" ? login(data) : register(data))
    } catch (caught) {
      setError(caught)
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="auth-layout">
      <section className="auth-story">
        <div className="auth-story__content">
          <span className="auth-brand"><img className="brand__mark" src="/brand/baseball-hub-logo.png" alt="" /> Baseball Hub</span>
          <p className="eyebrow eyebrow--light">The calm side of game day</p>
          <h1>One clubhouse for every roster, inning, and family update.</h1>
          <p>Plan the week, build fair lineups, and keep every coach, player, and family on the same page.</p>
          <div className="auth-proof">
            <span><CalendarDays size={18} /><span><strong>Your season in one place</strong><small>Rosters, schedules, and lineups</small></span></span>
            <span><Sparkles size={18} /><span><strong>Fair, flexible lineups</strong><small>Adjust quickly before first pitch</small></span></span>
            <span><UsersRound size={18} /><span><strong>Families stay ready</strong><small>Share schedules and updates</small></span></span>
          </div>
        </div>
      </section>
      <section className="auth-panel">
        <div className="auth-card">
          <p className="eyebrow">{mode === "login" ? "Welcome back" : "Build your clubhouse"}</p>
          <h2>{mode === "login" ? "Sign in to Baseball Hub" : "Create your coach account"}</h2>
          <p>{mode === "login" ? "Your next game plan is waiting." : "Start with your details. Add teams and players next."}</p>
          <ErrorNotice error={error} />
          <form onSubmit={submit} className="form-stack">
            {mode === "register" ? (
              <div className="form-grid">
                <label>First name<input name="first_name" autoComplete="given-name" required /></label>
                <label>Last name<input name="last_name" autoComplete="family-name" /></label>
              </div>
            ) : null}
            <label>Email address<input name="email" type="email" autoComplete="email" required /></label>
            <label>Password<input name="password" type="password" autoComplete={mode === "login" ? "current-password" : "new-password"} minLength="8" required /></label>
            {mode === "register" ? <label>Confirm password<input name="password_confirmation" type="password" autoComplete="new-password" minLength="8" required /></label> : null}
            <Button type="submit" disabled={busy}>{busy ? "Working…" : mode === "login" ? "Sign in" : "Create account"}</Button>
          </form>
          <button className="text-button" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(null) }}>
            {mode === "login" ? "New here? Create an account" : "Already have an account? Sign in"}
          </button>
          {mode === "login" ? <Link className="text-button" to="/forgot-password">Forgot your password?</Link> : null}
          <p className="security-note"><Check size={15} /> Your account information stays private and protected.</p>
        </div>
      </section>
    </main>
  )
}
